import React from "react"

export const SPA_APP_CONTEXT = "spa"
export const MIXED_APP_CONTEXT = "mixed"
export const AppTypeContext = React.createContext(SPA_APP_CONTEXT)
